import sarahPic from "@/public/images/artists/sarah.png";
import { Artist } from "@/types/types";

export const sarah = {
  id: "209",
  name: "Sarah",
  image: sarahPic,
  description: `Sarah's voice has a distinct, throaty quality that defines her sound. Rich and full, it's delivered with bold energy, effortlessly moving between depth and brightness.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsarah-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Kids",
        "Dance",
        "Soul",
        "Funk",
        "Jazz",
        "Soundtrack",
        "Unprocessed",
      ],
      secondary: ["Teen"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 51,
        high: 70,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
